var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({attrs:{"rounded":"","icon":!!_vm.icon,"color":_vm.icon ? '' : 'primary',"disabled":_vm.disabled || _vm.isFetching},on:{"click":function($event){return _vm.$emit('click')}}},'v-btn',_vm.$attrs,false),[(_vm.icon)?_c('v-icon',[_vm._v(_vm._s(_vm.icon))]):_c('span',[_vm._v(_vm._s(_vm.label || _vm.$t('common.save')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }